import { useContext } from 'react';

import { ReferringPageContext } from './ReferringPageProvider';

export default function useReferringPage() {
  return useContext(ReferringPageContext);
}
